import { render, staticRenderFns } from "./ViewShippoRate.vue?vue&type=template&id=8f6a24a0&scoped=true&lang=pug"
import script from "./ViewShippoRate.vue?vue&type=script&lang=js"
export * from "./ViewShippoRate.vue?vue&type=script&lang=js"
import style0 from "./ViewShippoRate.vue?vue&type=style&index=0&id=8f6a24a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6a24a0",
  null
  
)

export default component.exports